export const MODULE_SHORT_DISPLAY_NAME = "Super Admin";

export default {
  MODULE_SHORT_DISPLAY_NAME,
};
